'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Breadcrumbs;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./styles.css');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
* Breadcrumbs are used to note the path of a record and help
* the user to navigate back to the parent.
* @category Layout
*/


function Breadcrumbs(props) {
  var children = props.children,
      className = props.className,
      style = props.style;
  return _react2.default.createElement('nav', {
    'aria-label': 'Breadcrumbs',
    style: style,
    className: className
  }, _react2.default.createElement('ol', {
    className: 'rainbow-breadcrumbs'
  }, children));
}

Breadcrumbs.propTypes = {
  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes2.default.string,

  /** An object with custom style applied to the outer element. */
  style: _propTypes2.default.object,

  /**
  * This prop that should not be visible in the documentation.
  * @ignore
  */
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.object])
};
Breadcrumbs.defaultProps = {
  className: undefined,
  style: undefined,
  children: []
};